import React from 'react';
import './ColorSnippet.css';

const BackgroundColorSnippet = () => {
  return (
    <pre>
      <code className="ColorSnippet">
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-wall-day</span><span class="cln">"</span><span class="cn">&gt;</span>day<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-wall-night</span><span class="cln">"</span><span class="cn">&gt;</span>night<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-wall-main</span><span class="cln">"</span><span class="cn">&gt;</span>main<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-wall-vice</span><span class="cln">"</span><span class="cn">&gt;</span>vice<span class="cn">&lt;/div&gt;</span><br />

      </code>
    </pre>
  );
}
const ColorSnippet = () => {
  return (
    <pre>

      <code className="ColorSnippet">
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-text-main</span><span class="cln">"</span><span class="cn">&gt;</span>main<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-text-vice</span><span class="cln">"</span><span class="cn">&gt;</span>vice<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-text-body</span><span class="cln">"</span><span class="cn">&gt;</span>body<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-text-body2</span><span class="cln">"</span><span class="cn">&gt;</span>body2<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-text-day</span><span class="cln">"</span><span class="cn">&gt;</span>day<span class="cn">&lt;/div&gt;</span><br />
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-text-night</span><span class="cln">"</span><span class="cn">&gt;</span>night<span class="cn">&lt;/div&gt;</span><br />

      </code>
    </pre>
  );
}


export { BackgroundColorSnippet, ColorSnippet };
